import { StrictMode } from 'react'

// Inter, self-hosted. Only the weights the console uses: each is a file the
// browser fetches, so shipping the family would cost eight requests to render
// four of them.
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'

import './styles/global.css'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { ConsoleClient } from './api/client'
import { SessionProvider } from './auth/SessionProvider'

const container = document.getElementById('root')
if (!container) {
  throw new Error('no #root element; index.html and main.tsx disagree')
}

createRoot(container).render(
  <StrictMode>
    {/* The Router lives here, not in App: the tests supply a MemoryRouter
        instead, which is what lets a route be asserted without a browser.
        CloudFront rewrites deep paths to index.html, so BrowserRouter's
        history URLs resolve on a reload. */}
    <BrowserRouter>
      <SessionProvider client={new ConsoleClient()}>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
)
